import type { PublicApiKey } from '#packages/apilib';
import type { createPinModeApi } from './pinModeWrapper';

export const PinModeApiKey: PublicApiKey<typeof createPinModeApi> = {
  name: 'PinModeApi',
  public: true,
};
